export const EMAIL = {
  CUSTOMER: 'customer@mixiedigital.com',
  GERMAN_CUSTOMER: 'B.Bleile@dlg.org',
};
